/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Eine Unterkunft finden`
};

const en_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Find accommodation`
};

const es_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Buscar alojamiento`
};

const fr_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Trouver un hébergement`
};

const it_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Trova un alloggio`
};

const nl_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Accommodatie zoeken`
};

const pt_map_controls__partner_hotel__long_label = /** @type {(inputs: {}) => string} */ () => {
	return `Encontrar alojamento`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel__long_label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.map_controls__partner_hotel__long_label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("map_controls__partner_hotel__long_label", locale)
	if (locale === "de") return de_map_controls__partner_hotel__long_label(inputs)
	if (locale === "en") return en_map_controls__partner_hotel__long_label(inputs)
	if (locale === "es") return es_map_controls__partner_hotel__long_label(inputs)
	if (locale === "fr") return fr_map_controls__partner_hotel__long_label(inputs)
	if (locale === "it") return it_map_controls__partner_hotel__long_label(inputs)
	if (locale === "nl") return nl_map_controls__partner_hotel__long_label(inputs)
	return pt_map_controls__partner_hotel__long_label(inputs)
};